import * as React from 'react'

import { Alert, Box, Button, Link, Text } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import Modal from 'modules/core/components/Modal'
import TextField from 'modules/core/components/TextField'
import i18n from 'modules/core/lib/i18n'

import { ActivatePayload } from 'modules/app_store/lib/SubscriptionAddonInstaller'
import { linkedInCompanyUrl, validLinkedInId } from 'modules/app_store/lib/linkedin'
import atsCompanies from 'modules/ats/store/collections/atsCompanies'

interface Props {
  onSuccess: (payload?: ActivatePayload | null | undefined) => Promise<boolean>
  onClose: () => void
}

const ActivateLinkedInLimitedListings = ({ onSuccess, onClose }: Props) => {
  const atsCompany = atsCompanies.current
  const [linkedinId, setLinkedinId] = React.useState<string>(atsCompany?.get('linkedin_id') || '')

  const valid = validLinkedInId(linkedinId)

  const onSubmit = () => {
    if (valid) {
      onSuccess({ linkedin_id: linkedinId })
      onClose()
    }
  }

  const checkIdUrl = linkedInCompanyUrl(linkedinId)

  return (
    <Modal
      illustration="id"
      title={i18n.t('app_store_v2.app_integrations.linkedin_limited_listings.modal.title_1')}
      description={i18n.t(
        'app_store_v2.app_integrations.linkedin_limited_listings.modal.description_1'
      )}
      onSubmit={onSubmit}
      onClose={onClose}
      footer={
        <>
          <Button type="secondary" onClick={onClose}>
            {i18n.t('common.close')}
          </Button>
          <Button disabled={!valid} submit>
            {i18n.t('common.save')}
          </Button>
        </>
      }
    >
      <Box gap="s32">
        <TextField
          label={i18n.t('app_store_v2.app_integrations.linkedin_limited_listings.modal.title_1')}
          value={linkedinId}
          onChange={(value) => setLinkedinId(value.toString())}
        />
        {checkIdUrl && (
          <Alert color="note">
            <Box flexDirection="column" gap="s16">
              <Text.Normal size="200">
                {i18n.t(
                  'app_store_v2.app_integrations.linkedin_limited_listings.modal.check_id_info',
                  {
                    check_id: i18n.t(
                      'app_store_v2.app_integrations.linkedin_limited_listings.modal.check_id'
                    ),
                  }
                )}
              </Text.Normal>
              <Link.Href href={checkIdUrl} target="_blank">
                {i18n.t('app_store_v2.app_integrations.linkedin_limited_listings.modal.check_id')}
              </Link.Href>
            </Box>
          </Alert>
        )}
      </Box>
    </Modal>
  )
}

export default observer(ActivateLinkedInLimitedListings)
